function fallbackCopyTextToClipboard(text) {
    let textArea = document.createElement('textarea');
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        document.execCommand('copy');
        displaySuccess();
    } catch (err) {
        displayFailure();
        console.error('Failed to copy text with fallback:', err);
    }

    document.body.removeChild(textArea);
}

function displaySuccess() {
    toastr.success(
        __('general.thing_copied', {thing: __('validation.attributes.password')}),
        __('general.clipboard'), {
            timeOut: 1800,
            progressBar: false,
        });
}

function displayFailure() {
    toastr.warning(__('general.copy_to_clipboard_failed'),
        __('general.clipboard'), {
            timeOut: 2800,
            progressBar: false,
        });
}

export function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }

    navigator.clipboard.writeText(text).then(() => {
        displaySuccess();
    }, function(err) {
        displayFailure();
        console.error('Async: Could not copy text: ', err);
    });
}
